import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/pro-light-svg-icons';
import { faHeart as faHeartSolid } from '@fortawesome/pro-solid-svg-icons';
import cn from 'classnames';
import './ProductHeart.scss';

import { isProductIdFavorited } from '../../../Helpers/shop_helpers';

import ProductHeartOverlay from './ProductHeartOverlay';

const ProductHeart = props => {
  const { user, product, pinWithoutProduct } = props;

  // Show Product Heart Overlay
  const [isShowingOverlay, setIsShowingOverlay] = React.useState(false);
  const toggleOverlay = e => {
    e.stopPropagation();
    e.preventDefault();
    setIsShowingOverlay(!isShowingOverlay);
    if (!isShowingOverlay) {
      window.__ADD_EVENT__('Shop - Product Heart Click', {
        'Is In Product Graph': !!product,
        Product_id: product?.id || `Pin ${props.pinWithoutProduct?.id}`,
        Title: product?.title || props.pinWithoutProduct?.title,
        URL: product?.fallbackUrl || props.pinWithoutProduct?.link
      });
    }
  };

  // Allow force overriding heart visibility, this is used in disconnected pin cases
  const [overrideIsFavorited, setOverrideIsFavorited] = React.useState(false);

  // Favoriting
  const isFavorited = isProductIdFavorited(user, product?.id) || overrideIsFavorited;

  const additionalClasses = {
    loading: props.isLoading,
    favorited: isFavorited,
    favoriting: props.isFavoriting,
    unfavoriting: props.isUnfavoriting
  };

  const heart = (
    <div className='favorite-outer-container'>
      <div onClick={toggleOverlay} className={cn('favorite', additionalClasses)}>
        <FontAwesomeIcon
          style={{
            ...(props.size && { fontSize: props.size })
          }}
          icon={isFavorited ? faHeartSolid : faHeart}
        />
      </div>
    </div>
  );

  return isShowingOverlay ? (
    <ProductHeartOverlay
      product={product}
      pinWithoutProduct={pinWithoutProduct}
      closeOverlay={toggleOverlay}
      attribution={props.attribution}
      overrideIsFavorited={overrideIsFavorited}
      setOverrideIsFavorited={setOverrideIsFavorited}
    >
      {heart}
    </ProductHeartOverlay>
  ) : (
    heart
  );
};

ProductHeart.propTypes = {
  user: PropTypes.object.isRequired,
  product: PropTypes.object, // If the product is added to the product graph
  pinWithoutProduct: PropTypes.object, // If the product is not yet added to the product graph

  // If we want to attribute this to a curator or group
  attribution: PropTypes.object, // { Curator_id, CuratorGroup_id }

  // Optional UI
  size: PropTypes.number,
  isLoading: PropTypes.bool // Fades while loading containing cell
};

export default ProductHeart;
